import { Tidal } from "./Tidal.js";
import { validateTidalLicense } from "../../../base/index.js";
validateTidalLicense();
export {
  Tidal
};
//# sourceMappingURL=index.js.map
